<app-guest-new-component class="full-width-height" pageMode="true" [reset]="reset"></app-guest-new-component>